import React from "react";
import AppBar from "./AppBar";
import MemberStrip from "./MemberStrip";
import { useMandate } from "./MandateContext";
import { fmtDisplayDate, resolveValidFrom, resolveValidTo } from "./mandateValidity";

function Row({ label, value, badge }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 0", borderBottom: "1px solid #d1fae5" }}>
      <span style={{ fontSize: 12, color: "#6b7280" }}>{label}</span>
      {badge
        ? <span style={{ background: "#166534", color: "#fff", borderRadius: 20, padding: "2px 12px", fontSize: 12, fontWeight: 600 }}>{value}</span>
        : <span style={{ fontSize: 13, fontWeight: 600, textAlign: "right", maxWidth: "58%" }}>{value}</span>}
    </div>
  );
}

export default function MandateConfirmation({ onHome, onRetry, onBack }) {
  const { state } = useMandate();
  const isSuccess  = state.status === "success";
  const memberName = (state.selectedMember && state.selectedMember.memberName) || "";
  const mandateRef = state.mandateRef || state.authRequestId || "—";
  const partnerName = state.partnerName || state.paymentVendorName || "Payment Partner";
  const mandateStatus = state.mandateStatus || (isSuccess ? "Registered" : "Failed");
  const methodLabel = `${partnerName} UPI Autopay`;

  const today = new Date();
  const validFromDate = state.validFrom
    ? resolveValidFrom(state.validFrom, null)
    : (isSuccess ? today : null);
  const validFrom = validFromDate ? fmtDisplayDate(validFromDate) : "—";
  const validTo = validFromDate
    ? fmtDisplayDate(resolveValidTo(state.validFrom, state.validTo))
    : "—";

  return (
    <section className="main-sec" style={{ minHeight: "100vh" }}>
      <div className="container fix-width">
      <AppBar title="Confirmation" onBack={isSuccess ? undefined : onBack} />
      <MemberStrip memberName={memberName} partnerName={partnerName} />

      <div style={{ padding: "20px 14px 0", display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* ── SUCCESS STATE ── */}
        {isSuccess && (
          <>
            {/* Animated green checkmark */}
            <div style={{ margin: "8px 0 16px" }}>
              <svg viewBox="0 0 52 52" style={{ width: 72, height: 72 }}>
                <circle cx="26" cy="26" r="25" fill="none" stroke="#166534" strokeWidth="2"
                  style={{ strokeDasharray: 166, strokeDashoffset: 0 }} />
                <path fill="none" stroke="#166534" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"
                  d="M14 27 l9 9 l16-16"
                  style={{
                    strokeDasharray: 48,
                    strokeDashoffset: 0,
                    animation: "upi-draw 0.5s ease 0.1s both",
                  }} />
              </svg>
            </div>

            <div style={{ fontWeight: 700, fontSize: 20, color: "#111827", textAlign: "center", marginBottom: 6 }}>
              Mandate Registered Successfully!
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", textAlign: "center", marginBottom: 20, lineHeight: 1.6 }}>
              Your UPI Autopay mandate with <strong>{partnerName}</strong> has been activated for{" "}
              <strong>{memberName}</strong>.
            </div>

            {/* Mandate summary card */}
            <div style={{
              background: "#f0fdf4", border: "1px solid #bbf7d0",
              borderRadius: 16, padding: "14px 16px", width: "100%", marginBottom: 20,
            }}>
              <Row label="Mandate Ref ID"   value={mandateRef} />
              <Row label="Member Name"      value={memberName} />
              <Row label="Partner"          value={partnerName} />
              <Row label="Max Debit"        value={`₹${(state.maxBillingAmount || 0).toLocaleString("en-IN")}/month`} />
              <Row label="Valid From"       value={validFrom} />
              <Row label="Valid To"         value={validTo} />
              <Row label="Method"           value={methodLabel} />
              <Row label="Status"           value={mandateStatus.toUpperCase()} badge />
            </div>

            <button
              style={{ background: "#5f259f", color: "#fff", borderRadius: 8, border: "none", width: "100%", fontWeight: 700, marginBottom: 8, padding: "12px 0", fontSize: 15, cursor: "pointer" }}
              onClick={onHome}
            >
              Go to Home
            </button>
            {/* <button
              style={{ background: "transparent", color: "#5f259f", border: "2px solid #5f259f", borderRadius: 8, width: "100%", fontWeight: 700, marginBottom: 12, padding: "12px 0", fontSize: 15, cursor: "pointer" }}
              onClick={() => {}} // visual only — no PDF
            >
              Download Mandate Details
            </button> */}
          </>
        )}

        {/* ── FAILURE STATE ── */}
        {!isSuccess && (
          <>
            <div style={{ margin: "8px 0 16px", animation: "upi-shake 0.5s ease" }}>
              <svg viewBox="0 0 52 52" style={{ width: 72, height: 72 }}>
                <circle cx="26" cy="26" r="25" fill="none" stroke="#dc2626" strokeWidth="2" />
                <path fill="none" stroke="#dc2626" strokeWidth="4" strokeLinecap="round"
                  d="M17 17 l18 18 M35 17 l-18 18" />
              </svg>
            </div>
            <div style={{ fontWeight: 700, fontSize: 20, color: "#111827", textAlign: "center", marginBottom: 6 }}>
              Mandate Registration Failed
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", textAlign: "center", marginBottom: 20 }}>
              We could not register your autopay mandate with <strong>{partnerName}</strong> for{" "}
              <strong>{memberName}</strong>. Please try again.
            </div>
            <button
              style={{ background: "transparent", color: "#dc2626", border: "2px solid #dc2626", borderRadius: 8, width: "100%", fontWeight: 700, padding: "12px 0", fontSize: 15, cursor: "pointer" }}
              onClick={onRetry}
            >
              Try Again
            </button>
          </>
        )}
      </div>

      <style>{`
        @keyframes upi-draw {
          from { stroke-dashoffset: 48; }
          to   { stroke-dashoffset: 0; }
        }
        @keyframes upi-shake {
          0%,100% { transform: translateX(0); }
          20%,60% { transform: translateX(-6px); }
          40%,80% { transform: translateX(6px); }
        }
      `}</style>
      </div>
    </section>
  );
}
